/**
 * Client preview of count-session close: expected (snapshot) → counted.
 * Server still reconciles against live on-hand at accept time.
 */
import type { MfgInventoryCountLine } from "@/lib/manufacturing/types/inventoryCount";

export type CountClosePreviewChange = {
  line_id: string;
  label: string;
  code: string;
  expected_qty: number;
  counted_qty: number;
  quantity_delta: number;
};

export type CountClosePreview = {
  changes: CountClosePreviewChange[];
  skipped_uncounted: number;
  skipped_unchanged: number;
};

export function buildInventoryCountClosePreview(
  lines: readonly MfgInventoryCountLine[],
): CountClosePreview {
  const changes: CountClosePreviewChange[] = [];
  let skipped_uncounted = 0;
  let skipped_unchanged = 0;

  for (const line of lines) {
    if (line.counted_qty == null) {
      skipped_uncounted += 1;
      continue;
    }
    const expected = Number(line.expected_qty) || 0;
    const counted = Number(line.counted_qty);
    const delta = Number((counted - expected).toFixed(3));
    if (delta === 0) {
      skipped_unchanged += 1;
      continue;
    }
    changes.push({
      line_id: line.id,
      label: line.material_name ?? "Material",
      code: line.material_code ?? line.material_id.slice(0, 8),
      expected_qty: expected,
      counted_qty: counted,
      quantity_delta: delta,
    });
  }

  return { changes, skipped_uncounted, skipped_unchanged };
}
